import { Menu } from 'antd';
import MenuItem from 'antd/es/menu/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from 'shared/components';

export function MainMenu({ isExpiredTrial }) {
  const location = useLocation();

  // Extract the first segment of the path to use as the selected key
  const getSelectedKey = () => {
    const pathSegments = location.pathname.split('/');
    return pathSegments[1] || 'dashboard'; // Default to dashboard if path is just '/'
  };

  const selectedKey = getSelectedKey();

  return (
    <>
      <Menu
        selectedKeys={[selectedKey]}
        defaultSelectedKeys={[selectedKey]}>
        <MenuItem
          disabled={isExpiredTrial}
          key="dashboard"
          icon={<Icon name="dashboard" />}>
          <Link
            disabled={isExpiredTrial}
            to="/dashboard">
            Dashboard
          </Link>
        </MenuItem>
        {location.pathname.includes('/site/') && (
          <MenuItem
            key="site"
            className={'main-menu-child-item'}>
            Site
          </MenuItem>
        )}
        {location.pathname.includes('/cron/') && (
          <MenuItem
            key="cron"
            className={'main-menu-child-item'}>
            Cron
          </MenuItem>
        )}
        <MenuItem
          disabled={isExpiredTrial}
          key="notifications"
          icon={
            <Icon
              name="envelope"
              color="#fff"
              size={15}
            />
          }>
          <Link
            disabled={isExpiredTrial}
            to="/notifications">
            Notifications
          </Link>
        </MenuItem>
        <MenuItem
          disabled={isExpiredTrial}
          key="integrations"
          icon={
            <Icon
              name="integration"
              color="#ffffff"
            />
          }>
          <Link to="/integrations">Integrations</Link>
        </MenuItem>
        <MenuItem
          disabled={isExpiredTrial}
          key="status"
          icon={<Icon name="file-text" />}>
          <Link
            disabled={isExpiredTrial}
            to="/status">
            Status Page
          </Link>
        </MenuItem>
        <MenuItem
          disabled={isExpiredTrial}
          key="users"
          icon={<Icon name="group" />}>
          <Link
            disabled={isExpiredTrial}
            to="/users">
            Users
          </Link>
        </MenuItem>
        <MenuItem
          key="account"
          icon={<Icon name="accounts" />}>
          <Link to="/account">Account</Link>
        </MenuItem>
      </Menu>
    </>
  );
}
